module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0013.jpg?v=3fa34d46";